var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dx-grid',{ref:"grid",attrs:{"name":"tip-grid","url":_vm.url,"beforeSetupGrid":_vm.beforeSetupGrid,"columns":_vm.tipTransactionColumns,"title":_vm.title,"actions":_vm.actions,"expandedOptions":{
        enabled: true,
        allowExpandingAll: true,
        template: 'tip-transaction-details',
    },"summaryOptions":{
        enabled: true,
        columns: ['amount'],
    }}})}
var staticRenderFns = []

export { render, staticRenderFns }